import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "container-narrow" }
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "is-flex is-align-items-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "title is-5 mb-0" }, " Previous jobs ")
], -1)
const _hoisted_5 = {
  key: 0,
  class: "panel container-narrow"
}
const _hoisted_6 = {
  key: 1,
  class: "has-text-grey"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_job_form = _resolveComponent("job-form")!
  const _component_job_item = _resolveComponent("job-item")!
  const _component_loading_block = _resolveComponent("loading-block")!

  return (_ctx.jobCollection)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.operation)
            ? (_openBlock(), _createBlock(_component_job_form, {
                key: 0,
                operation: _ctx.operation,
                class: "box"
              }, null, 8, ["operation"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_ctx.jobs.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobs, (job) => {
                  return (_openBlock(), _createBlock(_component_job_item, {
                    key: job.clientPath,
                    job: job,
                    "detail-view": "MaterializeJob",
                    class: "panel-block"
                  }, null, 8, ["job"]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, " No jobs yet "))
        ])
      ]))
    : (_openBlock(), _createBlock(_component_loading_block, { key: 1 }))
}